// extracted by mini-css-extract-plugin
module.exports = {"error":"errorDisplay_error__1nfzM"};